import { createSelector } from "reselect"

const dataFormulaire = state => state.formulaireReducer.dataFormulaire
//******************************************************************************
//***************************** Selectors TEMPLATES ****************************
//******************************************************************************
// Get All templates
export const selectTemplatesList = createSelector([dataFormulaire], select => select?.templatesList)
// Get template by id
export const selectTemplate = createSelector([dataFormulaire], select => select?.template)
// Loader
export const selectLoaderDataForm = createSelector([dataFormulaire], select => select?.loaderData)
//******************************************************************************
//***************************** Selectors RESPONSES ****************************
//******************************************************************************
// Get All responses
export const selectReponsesList = createSelector([dataFormulaire], select => select?.responsesList)
// Get response by id
export const selectReponse = createSelector([dataFormulaire], select => select?.response)
// Get response by id templates
export const selectReponsesListByTemplate = createSelector(
  [dataFormulaire],
  select => select?.responsesListByTemplate
)
// Get id Reponse save
export const selectIdResponseSave = createSelector(
  [dataFormulaire],
  select => select?.idResponseSave
)
export const selectFilesForResponse = createSelector(
  [dataFormulaire],
  select => select?.filesForResponse
)
export const selectResponseGlobalInformation = createSelector(
  [dataFormulaire],
  select => select?.responsesGlobalInformation
)
export const selectWaitingSaving = createSelector([dataFormulaire], select => select?.waitingSaving)
//******************************************************************************
//*************************** Selectors LIST CHOICE ****************************
//******************************************************************************
// Get All List choice
export const selectChoicesList = createSelector([dataFormulaire], select => select?.choicesList)
// Get List choice by id
export const selectChoicesListSelect = createSelector(
  [dataFormulaire],
  select => select?.choicesListSelect
)
//******************************************************************************
//*************************** Selectors PLANNING  ****************************
//******************************************************************************
export const selectCardsPreparedPlanning = createSelector(
  [dataFormulaire],
  select => select?.cardsPreparedPlanning
)

export const selectPlanningIsLoading = createSelector(
  [dataFormulaire],
  select => select?.loaderPlanning
)

export const selectControlOccurrences = createSelector(
  [dataFormulaire],
  select => select?.controlOccurrences
)

export const selectActualFullOccurrence = createSelector(
  [dataFormulaire],
  select => select?.actualOccurrence
)
